import { DatePicker, Form, InputNumber, Select, Space } from "antd";
import TextArea from "antd/es/input/TextArea";
import WrappingModal from "../../../components/Modals/WrappingModal";
import AddingTable from "components/Tables/AddingTable";
import { SAFE_TYPES, SYDE_TYPES } from "constants/accountsConstants";

interface Props {
  form: any;
  isEditing: boolean;
  isModalOpen: boolean;
  handleOk: (values: any) => void;
  handleCancel: () => void;
  initialValues?: any;
  loading: boolean;
  subData: any[];
  setSubData: any;
  sellers: any[];
  costCenters: any[];
  currencies: any[];
  boxes: any[];
  banks: any[];
  branches: any[];
  vendors: any[];
  customers: any[];
}

const FormModal = ({
  form,
  isEditing,
  isModalOpen,
  handleOk,
  handleCancel,
  initialValues,
  loading,
  subData,
  setSubData,
  sellers,
  costCenters,
  currencies,
  boxes,
  banks,
  branches,
  customers,
  vendors,
}: Props) => {
  const columns = [
    {
      title: "م",
      dataIndex: "RowNo",
      width: 20,
      editable: false,
    },
    {
      title: "نوع الجهة",
      dataIndex: "SideType",
      editable: true,
      inputType: "select",
      options: SYDE_TYPES,
    },
    {
      title: "الجهة",
      dataIndex: "SideId",
      editable: true,
      inputType: "select",
      options: (record) =>
        record.SideType === 0
          ? customers.map((b) => ({
              value: b.CustomerID,
              label: b.CustomerName,
            }))
          : vendors.map((b) => ({ value: b.VendorID, label: b.VendorName })),
    },
    {
      title: "القيمة",
      dataIndex: "Value",
      editable: true,
      inputType: "number",
    },
    {
      title: "القيمة بالحروف",
      dataIndex: "ValueTafqit",
      editable: true,
      inputType: "text",
    },
    {
      title: "العملة",
      dataIndex: "CurrId",
      editable: true,
      inputType: "select",
      options: currencies.map((curr: any) => ({
        value: curr.CurrID,
        label: curr.CurrName,
      })),
    },
    {
      title: "معدل التحويل",
      dataIndex: "CurrRate",
      editable: true,
      inputType: "number",
    },
    {
      title: "نوع جهة الصرف",
      dataIndex: "SafeType",
      editable: true,
      inputType: "select",
      options: SAFE_TYPES,
    },
    {
      title: "جهة الصرف",
      dataIndex: "SafeId",
      editable: true,
      inputType: "select",
      options: (record) =>
        record.SafeType === 0
          ? boxes.map((b) => ({ value: b.BoxID, label: b.BoxName }))
          : banks.map((b) => ({ value: b.BankID, label: b.BankName })),
    },
    {
      title: "المندوب",
      dataIndex: "SellerId",
      editable: true,
      inputType: "select",
      options: sellers.map((seller: any) => ({
        value: seller.SellerID,
        label: seller.SellerName,
      })),
    },
    {
      title: "مركز التكلفة",
      dataIndex: "CostID",
      editable: true,
      inputType: "select",
      options: costCenters.map((center: any) => ({
        value: center.CostID,
        label: center.CostName,
      })),
    },
    {
      title: "ملاحظات",
      dataIndex: "Notes",
      editable: true,
      inputType: "text",
      width: 200,
    },
  ];

  return (
    <WrappingModal
      form={form}
      handleCancel={handleCancel}
      loading={loading}
      isModalOpen={isModalOpen}
      title={isEditing ? "تعديل حركة" : "إضافة حركة"}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onFinish={handleOk}
      >
        <Space direction="vertical" className="w-full" size="large">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <Form.Item name="DocDate" label="تاريخ الحركة">
              <DatePicker
                placeholder="تاريخ الحركة"
                className="w-full"
                format="YYYY-MM-DD"
              />
            </Form.Item>
            <Form.Item name="BranchId" label="الفرع">
              <Select
                placeholder="الفرع"
                showSearch
                optionFilterProp="children"
                options={branches.map((branch: any) => ({
                  value: branch.BranchID,
                  label: branch.BranchName,
                }))}
                className="w-full"
              />
            </Form.Item>
            {/* <Form.Item name="SerialId" label="المسلسل">
              <InputNumber placeholder="المسلسل" className="w-full" />
            </Form.Item> */}
          </div>

          {/* Sub Table */}
          <div className="overflow-x-auto">
            <AddingTable
              columns={columns}
              data={subData}
              setData={setSubData}
            />
          </div>

          <Form.Item name="Notes" label="ملاحظات">
            <TextArea rows={4} placeholder="اكتب ملاحظاتك" />
          </Form.Item>
        </Space>
      </Form>
    </WrappingModal>
  );
};

export default FormModal;
